(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GenerateList',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		Adzuki.ToggleableSection('[data-toggle="collapse"][data-cookie]');

		$('.date-search').click(function dateSearchClicked() {
			$('.birthday-container').each(function hideBirthdays() {
				$(this).addClass('hidden');
			});

			$('.anniversary-container').each(function hideAnniversarys() {
				$(this).addClass('hidden');
			});

			switch ($(this).data("type")) {
				case 'birthday':
					$('.birthday-container').each(function showBirthdays() {
						$(this).removeClass('hidden');
					});
				break;
				case 'anniversary':
					$('.anniversary-container').each(function showAnniversarys() {
						$(this).removeClass('hidden');
					});
				break;
				default:
				break;
			}
		});

		Adzuki.Typeahead(
			'.group-search',
			'/Groups/searchGroupsTypeahead',
			function select(item) {
				$form.find('#generatelist-group_id').val('');
				$form.find('#generatelist-tour_group_id').val('');
				$form.find('#generatelist-hotel_group_id').val('');

				if (item.type === 'cruise') {
					$form.find('#generatelist-group_id').val(item.mirror_group_id).trigger('change');
				}
				if (item.type === 'package') {
					$form.find('#generatelist-tour_group_id').val(item.mirror_tour_group_id).trigger('change');
				}
				if (item.type === 'lodging') {
					$form.find('#generatelist-hotel_group_id').val(item.mirror_hotel_group_id).trigger('change');
				}
			},
			function template(item) {
				var html = '';

				html += item.name;
				if (item.number) {
					if (item.name) {
						html += ' ';
					}
					html += '#'+item.number;
				}

				return html;
			}
		);

		// if Yes checked on page load, disable the other radio button for without a phone
		if ($('#generatelist-with_phone_numbers_only-0').is(":checked")) {
			onlyWithPhone($('input[name="form_component_data[GenerateList][with_phone_numbers_only]"]'));
		}

		// if Yes checked on page load, disable the other radio button for only with a phone
		if ($('#generatelist-without_phone_numbers_only-0').is(":checked")) {
			onlyWithoutPhone($('input[name="form_component_data[GenerateList][without_phone_numbers_only]"]'));
		}

		// when selecting "Yes" for Only Clients With a Phone Number, do not allow the user to select "Yes" for Only Clients Without a Phone Number. contradicts each other
		$('input[name="form_component_data[GenerateList][with_phone_numbers_only]"]').change(function onlyPhoneChanged() {
			onlyWithPhone($(this));
		});

		// when selecting "Yes" for Only Clients Without a Phone Number, do not allow the user to select "Yes" for Only Clients With a Phone Number. contradicts each other
		$('input[name="form_component_data[GenerateList][without_phone_numbers_only]"]').change(function withoutPhoneChanged() {
			onlyWithoutPhone($(this));
		});

		function onlyWithPhone($self) {
			var $ui_btn = $('.without_phone_numbers_only .btn-radio'),
			    $inputs = $('input[name="form_component_data[GenerateList][without_phone_numbers_only]"]');

			if ($self.val() === 'yes') {
				$('#generatelist-without_phone_numbers_only-1').trigger('click');
				$ui_btn.addClass('disabled');
				$inputs.attr('disabled', true);
			} else {
				$ui_btn.removeClass('disabled');
				$inputs.attr('disabled', false);
			}
		}

		function onlyWithoutPhone($self) {
			var $ui_btn = $('.with_phone_numbers_only .btn-radio'),
			    $inputs = $('input[name="form_component_data[GenerateList][with_phone_numbers_only]"]');

			if ($self.val() === 'yes') {
				$('#generatelist-with_phone_numbers_only-1').trigger('click');
				$ui_btn.addClass('disabled');
				$inputs.attr('disabled', true);
			} else {
				$ui_btn.removeClass('disabled');
				$inputs.attr('disabled', false);
			}
		}
	};

}(jQuery, window.Adzuki || {}));